<template>
  <div
    tabindex="0"
    class="flex items-start gap-3 p-4 bg-bkk-50 rounded-xl flex-col w-full justify-between cursor-pointer h-32"
  >
    <div class="flex items-center justify-center w-12 h-12 rounded-full">
      <slot name="icon" />
    </div>

    <p class="text-large leading-tight">
      <slot name="title" />
    </p>
  </div>
</template>
